<template>
  <div class="product-detail">
    <div class="detail-container">
      <!-- 左侧产品图片区域 -->
      <div class="image-section">
        <img  class="image-wrap"
          :src="require(`../assets/${product.pNmae}.png`)" 
          :alt="product.cname"
        >
       
      </div>

      <!-- 右侧参数表格区域 -->
      <div class="info-section">
        <!-- 产品标题 -->
        <div class="product-title">{{ product.cname }}</div>
        
        <!-- 参数表格 -->
        <div class="parameter-table">
          <div class="table-row">
            <div class="table-cell">类型</div>
            <div class="table-cell">焦油量</div>
            <div class="table-cell">烟气烟碱量</div>
            <div class="table-cell">一氧化碳量</div>
          </div>
          <div class="table-row">
            <div class="table-cell">{{ product.type }}</div>
            <div class="table-cell">{{ product.jyMeasure }}</div>
            <div class="table-cell">{{ product.yqyjMeasure }}</div>
            <div class="table-cell">{{ product.ylht || product.ylhtMeasure }}</div>
          </div>

          <div class="table-row">
            <div class="table-cell">烟长</div>
            <div class="table-cell">过滤嘴长</div>
            <div class="table-cell">包装形式</div>
            <div class="table-cell">单盒支数</div>
          </div>
          <div class="table-row">
            <div class="table-cell">{{ product.xyLength }}</div>
            <div class="table-cell">{{ product.glzcLength }}</div>
            <div class="table-cell">{{ product.packaging }}</div>
            <div class="table-cell">{{ product.total }}</div>
          </div>

          <div class="table-row">
            <div class="table-cell" style="grid-column: span 2">卷烟条码</div>
            <div class="table-cell" style="grid-column: span 2">条盒条码</div>
          </div>
          <div class="table-row">
            <div class="table-cell" style="grid-column: span 2">{{ product.number1 }}</div>
            <div class="table-cell" style="grid-column: span 2">{{ product.number2 }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部产品介绍 -->
    <div class="description-section">
      <div class="description-content">
        {{ product.describe }}
      </div>
    </div>

    <!-- 返回按钮 -->
    <button class="back-button" @click="goBack">返回产品列表</button>
  </div>
</template>

<script>
import ycItem from '../utils/pro.ts'

export default {
  name: 'ProductDetail',
  data() {
    return {
      product: {}
    }
  },
  created() {
    const productId = this.$route.params.id
    this.product = ycItem.find(item => item.index === productId) || ycItem[0]
  },
  methods: {
    goBack() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.product-detail {
  min-height: 100vh;
  background-image: url('../assets/backgroundImg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  
  display: flex;
  flex-direction: column;
}

.detail-container {
 display: grid;
 grid-template-columns: 30% auto;

padding: 10vh;

}

.image-section {
  display: flex;
  flex-direction: column;
  align-items: center;

}

.image-wrap {
  height: 300px;
}

.health-warning {
  font-size: 11px;
  color: #fff;
  text-align: center;
  background: rgba(0, 0, 0, 0.4);
  padding: 6px 12px;
  border-radius: 4px;
  font-weight: bold;
}

.info-section {
  padding:0 10%;

}

.product-title {

  color: white;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  padding: 20px;
  border: 1px solid #fff;
  border-bottom: none;

}

.parameter-table {
border: 1px solid #fff;
color: #fff;
font-weight: bold;
}

.table-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  border-bottom: 1px solid #fff;
}

.table-row:last-child {
  border-bottom: none;
}

.table-cell {
  padding: 10px 6px;
  text-align: center;
  font-size: 12px;
  border-right: 1px solid #fff;
}

.table-cell:last-child {
  border-right: none;
}



.description-section {

  color: white;
  padding: 0 15vh;
  border-radius: 6px;

  margin-bottom: 5vh;
  
}

.description-content {
  font-size: 14px;

  text-align: justify;
}

.back-button {
  display: block;
  margin: 20px auto;
  padding: 10px 25px;
  background: linear-gradient(135deg, #ff7e5f, #e5674f);
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s ease;
}

.back-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}
</style>